//全局注册组件
//左侧一级导航
import LeftLevelNavigation from '@/components/LeftLevelNavigation.vue';
//左侧二级导航
import LefSecondaryNavigation from '@/components/LefSecondaryNavigation.vue';
//弹窗组件
import Popup from '@/components/header/Popup.vue';
//转移月嫂组件
import TransferNanny from '@/components/basicBusiness/TransferNanny.vue';
//填写异常组件,填写停止合作组件
import FillIn from '@/components/basicBusiness/FillIn.vue';
//新增记录组件
import AddingRecord from '@/components/basicBusiness/AddingRecord.vue';
//新增记录组件
import BatchImports from '@/components/basicBusiness/BatchImports.vue';
//新增记录组件
import ModelLabel from '@/components/basicBusiness/ModelLabel.vue';
//新增商品
import AddShop from '@/components/shop/AddShop.vue';
//新增分类
import AddClassflx from '@/components/shop/AddClassflx.vue';
//新增分类
import WriteOff from '@/components/shop/WriteOff.vue';
//管理城市
import Address from '@/components/Address.vue';
//新增编辑佣金
import AddCommission from '@/components/AddCommission.vue';
//上传凭证
import UploadCredentials from '@/components/UploadCredentials.vue';
//上传凭证
import Delivery from '@/components/shop/Delivery.vue';
//售后
import ShouHou from '@/components/shop/ShouHou.vue';
//查看物流
import ViewLogistics from '@/components/shop/ViewLogistics.vue';
//标记类别
import TagCategory from '@/components/basicBusiness/TagCategory.vue';
//成交金额
import TransactionAmount from '@/components/basicBusiness/TransactionAmount.vue';
//提现密码
import WithdrawalVerification from '@/components/WithdrawalVerification.vue';
//数组存放接收的组件名
const components = [
  { name: "LeftLevelNavigation", con: LeftLevelNavigation },
  { name: "LefSecondaryNavigation", con: LefSecondaryNavigation },
  { name: "Popup", con: Popup },
  { name: "TransferNanny", con: TransferNanny },
  { name: "FillIn", con: FillIn },
  { name: "AddingRecord", con: AddingRecord },
  { name: "BatchImports", con: BatchImports },
  { name: "ModelLabel", con: ModelLabel },
  { name: "AddShop", con: AddShop },
  { name: "AddClassflx", con: AddClassflx },
  { name: "Address", con: Address },
  { name: "AddCommission", con: AddCommission },
  { name: "UploadCredentials", con: UploadCredentials },
  { name: "WriteOff", con: WriteOff },
  { name: "Delivery", con: Delivery },
  { name: "ShouHou", con: ShouHou },
  { name: "ViewLogistics", con: ViewLogistics },
  { name: "TagCategory", con: TagCategory },
  { name: "TransactionAmount", con: TransactionAmount },
  { name: "WithdrawalVerification", con: WithdrawalVerification },
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
